import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Modal, Button } from '_zari/core'

import * as FormGroups from './formGroups'
import { ValidationSchema } from './validation'

const ProductoAdicionalModal = ({ show, handleClose, idListaPrecio, dispatch }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      afectacion: '',
      cantidad: '',
      codigoProducto: '',
      nombreProducto: '',
      flagBolsa: false,
      incluyeIGV: true,
      nombreUnidadDeMedida: '',
      precio: 0,
      _idProductoPresentacion: '',
      _idProductoPresentacionPrecio: '',
      total: 0
    }
  }, [])

  const onSubmit = React.useCallback(
    data => {
      dispatch({ type: 'agregar', payload: data })
      __zariContext.toast('success', 'Producto adicional agregado.')
      handleClose()
    },
    [__zariContext, dispatch, handleClose]
  )

  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>Producto adicional</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={onSubmit} validationSchema={ValidationSchema}>
        {({ values, errors, touched, isSubmitting, setFieldValue, setValues, handleChange, handleSubmit }) => (
          <>
            <Modal.Body>
              <FormGroups.ProductoFormGroup
                vId={values._idProductoPresentacion}
                fIsSubmitting={isSubmitting}
                iError={errors._idProductoPresentacion}
                idListaPrecio={idListaPrecio}
                setValues={setValues}
                values={values}
              />
              <FormGroups.CantidadFormGroup
                fIsSubmitting={isSubmitting}
                iError={errors.cantidad}
                iTouched={touched.cantidad}
                setFieldValue={setFieldValue}
                handleChange={handleChange}
                vPrecio={values.precio || 0}
              />
              <FormGroups.NombreUnidaMedidaFormGroup
                fIsSubmitting={isSubmitting}
                iError={errors.nombreUnidadDeMedida}
                iTouched={touched.nombreUnidadDeMedida}
              />
              <FormGroups.PrecioFormGroup
                fIsSubmitting={isSubmitting}
                iError={errors.precio}
                iTouched={touched.precio}
                setFieldValue={setFieldValue}
                handleChange={handleChange}
                vCantidad={values.cantidad || 0}
              />
              <FormGroups.TotalFormGroup fIsSubmitting={isSubmitting} iError={errors.total} iTouched={touched.total} />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' disabled={isSubmitting} onClick={handleClose}>
                Cancelar
              </Button>
              <Button disabled={isSubmitting} onClick={handleSubmit}>
                Agregar
              </Button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(ProductoAdicionalModal)
